module.exports = __webpack_public_path__ + "img/bridge_long.ced319bd.png";